var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "action-container" }, [_vm._t("action")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }